/* istanbul ignore file */

import { useEffect, useRef, useState } from 'react';

import { useSize } from 'client-site-chrome-ui/components/molecules/DepartmentsNav/hooks/useSize';

export const useNavItemsWidth = () => {
  const [navItemsWidth, setNavItemsWidth] = useState(0);
  const navItems = useRef<HTMLAnchorElement[]>([]);
  const elementSize = useSize(navItems.current[0]);
  const setNavItemRef = (ref: HTMLAnchorElement, index: number) => (navItems.current[index] = ref);

  useEffect(() => {
    if (elementSize.width) {
      const width = navItems.current.reduce((total, item) => total + item.clientWidth, 0);
      setNavItemsWidth(width);
    }
  }, [navItems, elementSize]);

  return { setNavItemRef, navItemsWidth };
};
